import { useState, useEffect } from "react";
import camisas from "../data/camisas";
import CardCamisa from "../components/CardCamisa/CardCamisa";
import ModalCamisa from "../components/ModalCamisa/ModalCamisa";

export default function SelecaoBrasileira() {
  const [camisaSelecionada, setCamisaSelecionada] = useState(null);

  useEffect(() => {
    document.title = "Seleção Brasileira | Piazada dos Mantos";
  }, []);

  const camisasSelecao = camisas.filter((c) => c.time === "selecao-brasileira");

  const masculinas = camisasSelecao.filter(
    (c) =>
      c.tipo === "masculino" && !c.edicaoEspecial && c.categoria === "oficial"
  );

  const edicaoEspecial = camisasSelecao.filter((c) => c.edicaoEspecial);

  const femininas = camisasSelecao.filter(
    (c) => c.tipo === "feminino" && !c.edicaoEspecial
  );

  const jaquetas = camisasSelecao.filter(
    (c) => c.categoria === "jaqueta" && !c.edicaoEspecial
  );

  const blusas = camisasSelecao.filter(
    (c) => c.categoria === "blusa" && !c.edicaoEspecial
  );

  const renderGrid = (lista) => (
    <div className="grid">
      {lista.map((camisa) => (
        <CardCamisa
          key={camisa.id}
          camisa={camisa}
          onClick={setCamisaSelecionada}
        />
      ))}
    </div>
  );

  return (
    <div className="container">
      {/* HERO */}
      <section className="hero-selecao">
        <div className="hero-selecao-overlay">
          <h1>Seleção Brasileira</h1>
          <p>História, tradição e os mantos da amarelinha</p>
        </div>
      </section>

      {masculinas.length > 0 && (
        <>
          <h2 className="section-title">Camisas Masculinas</h2>
          {renderGrid(masculinas)}
        </>
      )}

      {edicaoEspecial.length > 0 && (
        <>
          <h2 className="section-title">Edição Especial</h2>
          {renderGrid(edicaoEspecial)}
        </>
      )}

      {jaquetas.length > 0 && (
        <>
          <h2 className="section-title">Jaquetas</h2>
          {renderGrid(jaquetas)}
        </>
      )}

      {blusas.length > 0 && (
        <>
          <h2 className="section-title">Blusas</h2>
          {renderGrid(blusas)}
        </>
      )}

      {femininas.length > 0 && (
        <>
          <h2 className="section-title">Camisas Femininas</h2>
          {renderGrid(femininas)}
        </>
      )}

      {camisaSelecionada && (
        <ModalCamisa
          camisa={camisaSelecionada}
          onClose={() => setCamisaSelecionada(null)}
        />
      )}
    </div>
  );
}
